module.exports = __webpack_public_path__ + "img/user.8c08a809.png";